import React       from 'react'
import { store }   from 'index'
import { objType } from 'types';

const useGetDestination = (
    val:      objType,
    guest:    boolean,
    disabled: boolean
) => {

    const destination = React.useMemo(() => {

        let dest = 'appPage';

        const state = store.getState();
        const page  = state.page.page;
        const userInfo = state.data.userInfo;

        console.log('[GUEST REDIRECT] useGetDestination called:', {
          guest,
          page,
          totalLikes: val.totalLikes,
          userEmail: userInfo.userEmail,
          semelMosad: userInfo.semelMosad,
          userFoundInTables: userInfo.userFoundInTables,
          disabled,
          valId: val.uid || val.lesson_id
        });

        // קודם בודקים מצב אורח - זה עדיפות גבוהה יותר
        // במצב אורח, תמיד לך ל-appIntro אם בדף הבית (לא משנה totalLikes)
        if (guest) {
          // אם אנחנו בדף הבית, לך ל-appIntro במקום getLost
          if (page === 'Root') {
            dest = 'appIntro';
            console.log('[GUEST REDIRECT] ✅ Guest on Root page → appIntro');
          } else {
            dest = 'getLost';
            console.log('[GUEST REDIRECT] Guest not on Root page → getLost');
          }
          return dest; // חזור מיד - לא צריך לבדוק עוד תנאים
        }
    
        // אם לא אורח, בודקים disabled
        if (!guest && disabled) {
          dest = 'getPlus';
          return dest;
        }

        if (!guest) {
          if (disabled) {
            dest = 'getPlus';
          }
          else if (val.disabledGrade) {
            dest = 'getGrade';
          }
        }

        // אם לא אורח ולא disabled, בודקים את הדף
        if (page === 'Root' && dest === 'appPage') {
          dest = 'newPage'
        }
        
        return dest;
    
      },[guest, disabled, val])

   
   return destination

}

export default useGetDestination

